import type { GetMergeRequestsQuery, GetMergeRequestsResponse } from '@clsplus/api-types/entity-merge'

import { requestApiJsonOrThrow } from '../request-handler'

function getMergeRequests(query: GetMergeRequestsQuery): Promise<GetMergeRequestsResponse> {
  return requestApiJsonOrThrow<GetMergeRequestsResponse>('entity-merge/merge-requests', {
    params: query,
  })
}

export const mergeRequestsQuery = (queryParams: GetMergeRequestsQuery) => ({
  queryKey: ['merge-requests', queryParams],
  queryFn: () => getMergeRequests(queryParams),
})
